<template>
  <div>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12 xl12 v-show="!isSearching" :style="showMovingMessage ? `margin-top: ${movingMessageHeight}px` : ''">
          <v-layout>
            <v-flex class="layout align-center">
              <v-icon
                color="black"
                medium
                class="ma-2"
              >low_priority</v-icon>
              <span class="strategio-folder-title">Base</span>
              <v-spacer></v-spacer>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12 xl12>
          <folder-list-item 
            v-for="f in folders" 
            :key="f.folderID" 
            :folder-data="f"
            :is-searching="isSearching"
            :add-inner-folder="addInnerFolder"
            :add-inner-report="addInnerReport"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import FolderListItem from './../folders/folder-list-item'

export default {
  name: 'structure-list',
  data () {
    return {
      showMovingMessage: false
    }
  },
  created () {

  },
  methods: {},
  components: {
    FolderListItem
  },
  props: {
    folders: {
      type: Array,
      default () {
        return []
      }
    },
    containedBy: {
      default () {
        return {}
      }
    },
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    searchInfo: {
      type: String,
      default () {
        return ''
      }
    },
    addInnerFolder: {
      type: Function,
      default () {
        return () => {}
      }
    },
    addInnerReport: {
      type: Function,
      default () {
        return () => {}
      }
    }
  }
}
</script>

<style scoped>
.strategio-folder-title {
  font-size: 32px;
  font-weight: bold;
  /* vertical-align: middle; */
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/structures/structure-list.vue